export const fontStyleOptions = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Arial Narrow', value: 'Arial Narrow' },
  { label: 'Calibri', value: 'Calibri' },
  { label: 'Cambria', value: 'Cambria' },
  { label: 'Georgia Regular', value: 'Georgia Regular' },
  { label: 'Proxima Nova Rg', value: 'Proxima Nova Rg' },
  { label: 'Segoe UI', value: 'Segoe UI' },
  { label: 'Segoe UI Light', value: 'Segoe UI Light' },
  { label: 'Serif', value: 'Serif' },
  { label: 'Source Sans Pro', value: 'Source Sans Pro' },
  { label: 'Tahoma', value: 'Tahoma' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Verdana', value: 'Verdana' },
];

export const headerFontSizeOptions = [
  { label: '10', value: '20' },
  { label: '10.5', value: '21' },
  { label: '11', value: '22' },
  { label: '12', value: '24' },
  { label: '14', value: '28' },
  { label: '16', value: '32' },
  { label: '18', value: '36' },
  { label: '20', value: '40' },
];

export const bodyFontSizeOptions = [
  { label: '8', value: '16' },
  { label: '9', value: '18' },
  { label: '10', value: '20' },
  { label: '10.5', value: '21' },
  { label: '11', value: '22' },
  { label: '12', value: '24' },
  { label: '14', value: '28' },
];

export const letterHeadTopMarginOptions = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
];

export const letterHeadBottomMarginOptions = [
  { label: '0', value: '1' },
  { label: '1', value: '2' },
  { label: '2', value: '3' },
  { label: '3', value: '4' },
  { label: '4', value: '5' },
  { label: '5', value: '6' },
  { label: '6', value: '7' },
  { label: '7', value: '8' },
  { label: '8', value: '9' },
  { label: '9', value: '10' },
  { label: '10', value: '11' },
];

export const followerTopMarginOptions = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
];

export const followerBottomMarginOptions = [
  { value: '1', label: '0' },
  { value: '2', label: '1' },
  { value: '3', label: '2' },
  { value: '4', label: '3' },
  { value: '5', label: '4' },
  { value: '6', label: '5' },
  { value: '7', label: '6' },
  { value: '8', label: '7' },
  { value: '9', label: '8' },
  { value: '10', label: '9' },
  { value: '11', label: '10' },
];

export const salutationOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
];

export const letterheadStyleOptions = [
  { label: 'Header/Footer', value: 'letter' },
  { label: 'Right Aligned', value: 'letter-r' },
  { label: 'Left Aligned', value: 'letter-l' },
  { label: 'Narrow Margins', value: 'letter-wide' },
];

export const signatureImageOptions = [
  { label: '1', value: '25' },
  { label: '2', value: '50' },
  { label: '3', value: '100' },
  { label: '4', value: '150' },
  { label: '5', value: '200' },
  { label: '6', value: '225' },
  { label: '7', value: '250' },
  { label: '8', value: '275' },
  { label: '9', value: '300' },
  { label: '10', value: '325' },
];

export const pmPriorityOptions = [
  { label: 'Partner', value: 'partner' },
  { label: 'Manager', value: 'manager' },
];

export const positionTypeOptions = [
  { label: 'None', value: 0 },
  { label: 'Partner', value: 1 },
  { label: 'Director', value: 2 },
  { label: 'Principal', value: 3 },
  { label: 'Senior Accountant', value: 4 },
  { label: 'Accountant', value: 5 },
  { label: 'Junior Accountant', value: 6 },
  { label: 'Bookkeeper', value: 7 },
  { label: 'Administrator', value: 8 },
];

export const chargeableRateOptions = [
  { label: 'Use firm rate', value: 0 },
  { label: '$400 (Partner)', value: 1 },
  { label: '$400 (Director)', value: 2 },
  { label: '$400 (Principal)', value: 3 },
  { label: '$300 (Senior Accountant)', value: 4 },
  { label: '$250 (Accountant)', value: 5 },
  { label: '$150 (Junior Accountant)', value: 6 },
  { label: '$90 (Bookkeeper)', value: 7 },
  { label: '$75 (Administrator)', value: 8 },
];
